var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileTiktokİcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 28C21.7314 28 28 21.7314 28 14C28 6.26855 21.7314 0 14 0C6.26855 0 0 6.26855 0 14C0 21.7314 6.26855 28 14 28ZM14.1732 7H16.5897C16.5897 8.78646 18.015 10.2471 19.8333 10.3063V12.7012C18.6553 12.6807 17.5399 12.2956 16.6318 11.6462V16.5361C16.6318 18.9902 14.6073 21 12.1076 21C9.60791 21 7.58333 19.0107 7.58333 16.5361C7.58333 14.082 9.56689 12.1133 12.0244 12.0723V14.4671C10.909 14.5081 9.99984 15.4196 9.99984 16.5361C9.99984 17.1491 10.2687 17.7005 10.6982 18.0811C11.0674 18.4069 11.5527 18.6051 12.0871 18.6051C13.2435 18.6051 14.1732 17.6732 14.1732 16.5361V7Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileTiktokİcon);
export default __webpack_public_path__ + "static/media/mobile-tiktok-icon.ef6c6b24461f0d2d194d777a6953b71f.svg";
export { ForwardRef as ReactComponent };